<template>
  <div class="auth-wrapper auth-v2">
    <div class="auth-inner">
      <Logo />

      <v-row class="auth-row ma-0">
        <v-col
          lg="8"
          class="d-none d-lg-block position-relative overflow-hidden pa-0"
        >
          <div class="auth-illustrator-wrapper">
            <!-- triangle bg -->
            <img
              height="362"
              class="auth-mask-bg"
              :src="
                require(`@/assets/images/misc/mask-v2-${
                  $vuetify.theme.dark ? 'dark' : 'light'
                }.png`)
              "
            />
          </div>
        </v-col>

        <v-col lg="4" class="d-flex align-center auth-bg pa-10 pb-0">
          <v-row>
            <v-col cols="12" sm="8" md="6" lg="12" class="mx-auto">
              <v-card flat>
                <v-card-text>
                  <p class="text-2xl font-weight-semibold text--primary mb-2">
                    Iniciar sesión! 👋🏻
                  </p>
                </v-card-text>

                <!-- login form -->
                <v-card-text>
                  <v-form ref="loginForm" @submit.prevent="handleFormSubmit">
                    <FormTextField
                      v-model="formData.email"
                      label="Email"
                      placeholder="Email"
                      :rules="[validators.required, validators.emailValidator]"
                      class="mb-6"
                    />

                    <FormTextFieldPassword
                      v-model="formData.password"
                      label="Contraseña"
                      placeholder="********"
                      :rules="[validators.required]"
                      class="mb-2"
                    />

                    <div
                      class="d-flex align-center justify-space-between flex-wrap"
                    >
                      <!-- forget link -->
                      <!-- <router-link
                        :to="{ name: 'auth-forgot-password' }"
                        class="ms-3"
                      >
                        Recuperar contraseña
                      </router-link> -->
                    </div>

                    <v-btn
                      :loading="loading"
                      :disabled="loading"
                      block
                      color="primary"
                      type="submit"
                      class="mt-6"
                      rounded
                    >
                      Iniciar
                    </v-btn>
                  </v-form>
                </v-card-text>

                <!-- create new account  -->
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import Logo from "@/components/general/Logo";
import FormTextField from "@/components/forms/TextField";
import FormTextFieldPassword from "@/components/forms/TextFieldPassword";

import { ref, getCurrentInstance, reactive } from "@vue/composition-api";
import { required, emailValidator } from "@core/utils/validation";
import api from "@/services";
import { useRouter } from "@core/utils";
import store from '@/store'

export default {
  components: {
    Logo,
    FormTextField,
    FormTextFieldPassword,
  },
  setup() {
    const vm = getCurrentInstance().proxy;
    const { router } = useRouter();

    const loading = ref(false);
    const loginForm = ref(null);
    const formData = reactive({
      email: "",
      password: "",
    });

    const isPasswordVisible = ref(false);

    const onToggleLoading = () => {
      loading.value = !loading.value;
    };

    const handleFormSubmit = async () => {
      const isFormValid = loginForm.value.validate();

      if (!isFormValid) return;

      onToggleLoading();

      try {
        const { data } = await api.login(formData);
        const { data: response } = data;
        const { token: accessToken, user } = response;

        if (accessToken) {
          localStorage.setItem("accessToken", accessToken);
          store.dispatch('auth/onAuthUser', user)
          router.push("/");
        }
      } catch (error) {
        vm.$alert("Credenciales invalidas, intente nuevamente", null, "error");
      }

      onToggleLoading();
    };

    return {
      handleFormSubmit,

      isPasswordVisible,
      formData,
      loading,

      validators: {
        required,
        emailValidator,
      },

      // Template Refs
      loginForm,

    };
  },
};
</script>

<style lang="scss" scoped>
@import "@core/preset/preset/pages/auth.scss";
</style>
